import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import data from '@/store/modules/data.js'
import error from '@/store/modules/error.js'
import evaluate from '@/store/modules/eval.js'
import help from '@/store/modules/help.js'
import mode from '@/store/modules/mode.js'
import result from '@/store/modules/result.js'
import search from '@/store/modules/search.js'
import view from '@/store/modules/view.js'
import general from '@/store/modules/general.js'

export default new Vuex.Store({
  modules:{
    data, 
    error,
    evaluate,
    help,
    mode,
    result,
    search,
    view,
    general,
  },
  strict: true
})
